import React, { useCallback, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import SessionHistoryContent from './components/session-history-content/SessionHistoryContent';
import useSessionHistory from './hooks/useSessionHistory';

import scss from './SessionHistoryPanel.module.scss';

function SessionHistoryPanel() {
  const { t } = useTranslation('story');
  const [isOpen, setIsOpen] = useState(false);

  const { isAdmin, handleSelectSession, handleChangePage } = useSessionHistory({ isActive: isOpen });

  const handleToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  if (!isAdmin) {
    return null;
  }

  return (
    <aside className={clsx(scss.panel, isOpen && scss.panelOpen)}>
      <button type='button' className={scss.toggle} onClick={handleToggle} aria-label={t('sessionHistory')}>
        <span className={scss.toggleChevrons}>
          <Icon icon={ICONS.CaretUp} className={scss.toggleIcon} />
          <Icon icon={ICONS.CaretUp} className={scss.toggleIcon} />
        </span>
      </button>

      {!isOpen ? (
        <span className={scss.collapsedLabel}>{t('sessionHistory')}</span>
      ) : (
        <SessionHistoryContent
          isAdmin={isAdmin}
          onSelectSession={handleSelectSession}
          onChangePage={handleChangePage}
        />
      )}
    </aside>
  );
}

export default SessionHistoryPanel;
